export const iconFontAwesomeEnergyBolt = (
	<i className="fa-solid fa-bolt"></i>
);
